import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentTeaserContentModel } from '@libs/cms/models';
import { provideContentTrackingContext } from '@libs/shared/tracking';
import { ContentTeaserComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-content-teasers',
  templateUrl: './content-teasers.component.html',
  styleUrls: ['./content-teasers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentTeaserComponent,
  ],
  providers: [
    provideContentTrackingContext(ContentTeasersComponent),
  ],
})
export class ContentTeasersComponent extends ContentBaseComponent<ContentTeaserContentModel> {
}
